module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-32x9-f2aa3702e43e697f352701d131b805cc.jpg";